import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { connect } from "dva";
import EnhancerWaterMark from "watermark-enhancer";
import { parse } from "qs";
import { Button, Popconfirm } from "antd";
import router from 'umi/router';
import { queryCurrent } from "@/services/user";
import { getComposeUrl } from '@/utils/common';
import styles from "@/pages/Home/Salary/Manage/index.less";
import Container from "../../../../../components/Container";
import Detail from "../../Components/Detail";
import LockedWarn from '../../Components/LockedModal/LockedWarn'
import LockedModal from '../../Components/LockedModal';
import PwdModal from '../../Components/PwdModal';
import { SALARY_CAT_LOCKED } from '../../constants';

const renderEffectContent = async () => {
  const { phone, users = [] } = await queryCurrent();
  const { userName } = users.find(user => user.userType && user.userType !== "学生");
  return `${userName}${phone.slice(-4)}`;
};

@EnhancerWaterMark({
  width: "280",
  height: "300",
  rotate: "335",
  font: "16px normal  PingFang SC",
  fillStyle: "rgba(184, 184, 184, 0.2)",
  asyncContent: renderEffectContent
}, {
  content: "",
  color: "black",
  background: "white"
})

@connect(({ manage }) => ({
  ...manage,
}))

class Index extends Component {
  rootEle = null;
  rootSlaveEle = null;

  constructor(props) {
    super(props);
    this.query = parse(window.location.search.split("?")[1]);
  }

  componentDidMount() {
    this.fetchList(1, 10);
    this.rootEle = document.getElementById('root');
    this.rootSlaveEle = document.getElementById('root-slave');
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "manage/save",
      payload: {
        detailsData: {},
      }
    });

  }

  onPageChange = (page, pageSize) => {
    this.fetchList(page, pageSize);
  }

// 关闭密码超过次数锁定问题提示
  handleCloseLock = () => {
    this.handleSave({ lockedVisible: false });
  };

  // 取消输入密码
  handleCancelPwd = () => {
    this.handleSave({ pwdVisible: false });
  };

  // 确认提交密码
  handleSendPwd = password => {
    const { dispatch } = this.props;
    const { id } = this.query
    dispatch({
      type: 'manage/verifyPassword',
      payload: {
        password,
        type: 'detail',
        id,
      },
      callback: this.handleCallBack
    });
  };

  handleSave = payload => {
    const { dispatch } = this.props;
    dispatch({
      type: 'manage/save',
      payload
    });
  };

  // 删除
  handleDel = () => {
    const { dispatch } = this.props;
    const { id } = this.query

    dispatch({
      type: 'manage/fetchDel',
      payload: {
        id,
      },
    }).then(() => {
      window.history.back();
    });
  };

  // 撤回、提醒、立即发布、补发
  handleFetchRequest = ({ fetchType }) => {
    const { dispatch } = this.props;
    const { id } = this.query
    dispatch({
      type: 'manage/fetchRequest',
      payload: {
        id,
        fetchType, // 接口类型
      },
    }).then(() => {
      // window.history.back();
      this.fetchList(1, 10)
    });
  };

  // 去编辑页
  handleGoToCreateOrEdit = (type = 'create') => {
    const { id } = this.query;
    const { detailsData } = this.props;
    const { sendStatus } = detailsData;
    router.push(getComposeUrl(`/wages/management/edit?id=${id}&type=${type}&sendStatus=${sendStatus}`));
  };

  // 删除
  renderDelBtn = () => {
    const { id } = this.query
    return (
      <Popconfirm
        title='确认删除?'
        okText="确认"
        cancelText="取消"
        className="del"
        onConfirm={() => this.handleDel(id)}
      >
        <Button>删除</Button>
      </Popconfirm>
    );
  };

  // 撤回
  renderRecallInformBtn = () => {
    const { id } = this.query
    return (
      <Popconfirm
        overlayStyle={{ zIndex: 1051 }}
        title={<div>撤回后已通知的用户将不可继续查看该工资条<br />是否确认撤回？</div>}
        okText="确认"
        cancelText="取消"
        className="del"
        onConfirm={() => this.handleFetchRequest({ id, fetchType: 'recall' })}
      >
        <Button>撤回</Button>
      </Popconfirm>
    );
  };

  // 待发布 状态下 操作
  renderNoReleasedAction = ({ platform }) => {
    const { id } = this.query
    return [
      {
        type: "default",
        title: this.renderDelBtn(id),
      },
      {
        type: "default",
        title: "编辑",
        click: () => this.handleGoToCreateOrEdit('edit', id, platform),
      },
      {
        type: "primary",
        title: "发布",
        click: () => this.handleFetchRequest({ id, fetchType: 'publish' }),
      }
    ];
  };

  // 发布成功 状态下 操作
  renderReleaseAction = ({ platform }) => {
    const { id } = this.query
    return [
      {
        type: "default",
        title: this.renderRecallInformBtn(id),
      },
      {
        type: "default",
        title: "编辑",
        click: () => this.handleGoToCreateOrEdit('edit', id, platform),
      },
      {
        type: "primary",
        title: "提醒",
        click: () => this.handleFetchRequest({ id, fetchType: 'remind' }),
      }
    ];
  };

  // 已撤回 状态下 操作
  renderRevokeAction = ({ platform }) => {
    const { id } = this.query
    return [
      {
        type: "default",
        title: this.renderDelBtn(id),
      },
      {
        type: "primary",
        title: "编辑",
        click: () => this.handleGoToCreateOrEdit('edit', id, platform),
      },
    ];
  };

  // 草稿 状态下 操作
  renderDraftAction = ({ platform }) => {
    const { id } = this.query
    return [
      {
        type: "default",
        title: this.renderDelBtn(id),
      },
      {
        type: "primary",
        title: "编辑",
        click: () => this.handleGoToCreateOrEdit('edit', id, platform),
      },
    ];
  };

  // 发布失败 状态下 操作
  renderFailedAction = ({ platform }) => {
    const { id } = this.query
    return [
      {
        type: "default",
        title: this.renderDelBtn(id),
      },
      {
        type: "primary",
        title: "编辑",
        click: () => this.handleGoToCreateOrEdit('edit', id, platform)
      }
    ];
  };


  // 发布中 状态下 操作
  renderNoAction = () => {
    return null;
  };

  // 底部按钮属性
  handleFooterProps = list => {
    if (typeof list !== 'object' || !Array.isArray(list)) {
      return null;
    }
    const demFooter = list.map(item => {
      const { type, click, title } = item;

      if (typeof title === 'string') {
        return (
          <Button type={type} onClick={click || (() => { })}>
            {title}
          </Button>
        )
      }
      return title;
    });
    return demFooter;
  };

  switchSendState = detail => {
    const { sendStatus } = detail || {};

    // "1": "草稿",
    // "6": "撤回"
    // "5": "发布失败",

    // "2": "待发布",
    // "3": "发布中",
    // "4": "发布成功",

    switch (sendStatus) {
      case 1:
        return this.renderDraftAction(detail);
      case 2:
        return this.renderNoReleasedAction(detail);
      case 3:
        return this.renderNoAction(detail);
      case 4:
        return this.renderReleaseAction(detail);
      case 5:
        return this.renderRevokeAction(detail);
      case 6:
        return this.renderRevokeAction(detail);
      default:
        return this.renderNoAction(detail);
    }
  };

  fetchList(page, pageSize) {
    const { dispatch } = this.props;
    const { id } = this.query
    dispatch({
      type: 'manage/fetchDetail',
      payload: {
        id,
        page,
        pageSize,
      },
    })
  }

  // 底部按钮渲染
  renderFooterBtn = () => {
    const { detailsData } = this.props;
    return {
      states: true,
      demFooter: this.handleFooterProps(this.switchSendState(detailsData)),
    }
  }

  render() {
    const { detailsData, salaryCatAuth, lockedVisible, pwdVisible } = this.props;
    const { sendFailedReason = '', sendStatus } = detailsData || {}

    const alertParams = {
      states: sendStatus === 5, // true为展示 false不展示
      type: 'error', // 错误类型（success info warning error）四种，默认为warning类型
      message: sendFailedReason, // 展示的内容
    };
    return (
      <Container
        defaultPadding
        breStates
        alertParams={alertParams}
        footerParams={!salaryCatAuth ? this.renderFooterBtn() : {}}
        isSplitBar
      >
        {!salaryCatAuth ? (
          <Detail data={detailsData} from="manage" onPageChange={this.onPageChange} />
        ) : (
          <>
            <div className={styles['hide-cover']} />
            {salaryCatAuth === SALARY_CAT_LOCKED && (this.rootEle || this.rootSlaveEle)
            && ReactDOM.createPortal(<LockedWarn />, (this.rootEle || this.rootSlaveEle))}
            <LockedModal visible={lockedVisible} handleClose={this.handleCloseLock} />
            <PwdModal
              visible={pwdVisible}
              onCancel={this.handleCancelPwd}
              onOk={this.handleSendPwd}
            />
          </>
        )}
      </Container>
    );
  }
}

export default Index;
